import { CompetitionNavFiltersState } from '../types';
import { ReduxState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {CompetitionNavFiltersState} The Competition Nav Filters state.
 */
export const filtersSelector = (state) => state.competitionNav.nav.filters;
